import React, { Component } from 'react';
import { Link, withRouter } from 'react-router'
import Constants from './Constants.js';
import NavLink from './NavLink.js';

import '../../public/material-dashboard/assets/css/material-dashboard.css';

/*

                    <NavLink to={`${Constants.APP_URL_PREFIX}/dashboard/cumulative_signups_by_month`}>
                      <i className="material-icons">dashboard</i>
                            <p>Cumulative Signups By Month</p>
                    </NavLink>

                    <NavLink to={`${Constants.APP_URL_PREFIX}/dashboard/cumulative_students_by_month`}>
                      <i className="material-icons">dashboard</i>
                            <p>Cumulative Students By Month</p>
                    </NavLink>
*/

class Dashboard extends Component {

  render() {

    return (

      <div className="wrapper">
        <div className="sidebar" data-color="purple" data-image="../assets/img/sidebar-1.jpg">

          <div className="logo">
            <a href="/" className="simple-text">
              Literator Pulse
            </a>
          </div>

          <div className="sidebar-wrapper">
                <ul className="nav">

                    <NavLink to={`${Constants.APP_URL_PREFIX}/dashboard/active_new_users`}>
                      <i className="material-icons">dashboard</i>
                      <p>Active New Users</p>
                    </NavLink>

                    <NavLink to={`${Constants.APP_URL_PREFIX}/dashboard/teacher_activity`}>
                      <i className="material-icons">dashboard</i>
                            <p>Teacher Activity</p>
                    </NavLink>

                    <NavLink to={`${Constants.APP_URL_PREFIX}/dashboard/website_sessions`}>
                      <i className="material-icons">dashboard</i>
                            <p>Website Sessions</p>
                    </NavLink>

                    <NavLink to={`${Constants.APP_URL_PREFIX}/dashboard/schedule_demo_funnel`}>
                      <i className="material-icons">dashboard</i>
                            <p>Schedule Demo Funnel</p>
                    </NavLink>

                    <NavLink to={`${Constants.APP_URL_PREFIX}/dashboard/rolling_active_users`}>
                      <i className="material-icons">dashboard</i>
                            <p>Rolling Active Users</p>
                    </NavLink>

                    <NavLink to={`${Constants.APP_URL_PREFIX}/dashboard/create_demo_account`}>
                      <i className="material-icons">dashboard</i>
                            <p>Create Demo Account</p>
                    </NavLink>

                </ul>
          </div>
        </div>

        <div className="main-panel">
          <nav className="navbar navbar-transparent navbar-absolute">
            <div className="container-fluid">
              <div className="navbar-header">
                    <Link to={`${Constants.APP_URL_PREFIX}/logout`}>
                      Logout
                    </Link>

              </div>
              <div className="collapse navbar-collapse">
                <ul className="nav navbar-nav navbar-right">
                  <li>
                    <a href="#pablo" className="dropdown-toggle" data-toggle="dropdown">
                       <i className="material-icons">person</i>
                       <p className="hidden-lg hidden-md">Profile</p>
                     </a>
                  </li>
                </ul>


              </div>
            </div>
          </nav>



          <div className="container-fluid">
              {this.props.children}

              <div className="row">

              </div>
          </div>


        </div>
      </div>


    );
  }
}

export default withRouter(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard.js